export const PERMISSIONS = {
  addUsers: 'add:users',
  removeUsers: 'remove:users',
  addEntities: 'add:entities',
  removeEntities: 'remove:entities',
  requestDispute: 'request:dispute',
};
